(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gs-org-selector", [], factory);
	else if(typeof exports === 'object')
		exports["gs-org-selector"] = factory();
	else
		root["gs-org-selector"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__org_selector__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__org_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__org_selector__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "orgSelector", function() { return __WEBPACK_IMPORTED_MODULE_0__org_selector___default.a; });


var Plugin = {
    install: function install(Vue) {
        Vue.component('org-selector', __WEBPACK_IMPORTED_MODULE_0__org_selector___default.a);
    }
};

/* harmony default export */ __webpack_exports__["default"] = (Plugin);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(9),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-744b9c58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7ec886fc", content, true, {});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".bsp_org_sel_box[data-v-744b9c58]{padding:10px}.bsp_org_sel_box .content-ht[data-v-744b9c58]{height:500px}.bsp_org_sel_box .left-org-tree[data-v-744b9c58]{float:left;border:1px solid #cee0f0;width:460px;overflow:hidden}.bsp_org_sel_box .right-org-list[data-v-744b9c58]{float:right;border:1px solid #cee0f0;width:410px}.bsp_org_sel_box .left-org-tree .org-search-box[data-v-744b9c58]{background:#f2f6fc;padding:5px 25px}.bsp_org_sel_box .org-selected-box[data-v-744b9c58]{background:#f2f6fc;padding:8px 15px}.bsp_org_sel_box .content-box[data-v-744b9c58]{height:458px;padding:5px 15px}.bsp_org_sel_box .table[data-v-744b9c58]{border:none;width:100%;table-layout:fixed}.bsp_org_sel_box .table td[data-v-744b9c58]{border:none}.bsp_org_sel_box .org-left[data-v-744b9c58]{width:92%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}.bsp_org_sel_box .org-del[data-v-744b9c58]{width:8%;text-align:right}.bsp_org_sel_box .org-del .img-box[data-v-744b9c58]{margin:7px 0 0;cursor:pointer}.bsp_org_sel_box .bsp-scroll[data-v-744b9c58]{overflow:overlay}.bsp_org_sel_box /deep/ .ivu-input[data-v-744b9c58]{height:30px;border-color:#cee0f0;font-size:15px!important}.bsp_org_sel_box /deep/ .ivu-tree ul li[data-v-744b9c58]{margin:2px 0}.bsp_org_sel_box /deep/ .ivu-input[data-v-744b9c58]:focus{border-color:#337bf5;box-shadow:inset 0 0 0 1000px #fff!important}.bsp_org_sel_box /deep/ .el-tree .ivu-icon[data-v-744b9c58]{font-size:20px!important;font-weight:700}.bsp_org_sel_box /deep/ .el-tree .el-checkbox__inner[data-v-744b9c58]{height:16px;width:16px;border:1px solid #cee0f0}.bsp_org_sel_box /deep/ .el-tree .el-checkbox__inner[data-v-744b9c58]:after{height:8px;left:5px;border:2px solid #fff;border-left:0;border-top:0}.bsp_org_sel_box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner[data-v-744b9c58],.bsp_org_sel_box /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-744b9c58]{border-color:#2b5fda;background-color:#2b5fda}.bsp_org_sel_box /deep/ .ivu-radio-wrapper[data-v-744b9c58]{margin-right:4px}.bsp_org_sel_box /deep/ .ivu-radio-inner[data-v-744b9c58]{border-color:#cee0f0}.bsp_org_sel_box /deep/ .ivu-radio-checked .ivu-radio-inner[data-v-744b9c58]{border-color:#2b5fda}.bsp_org_sel_box /deep/ .ivu-radio-checked .ivu-radio-inner[data-v-744b9c58]:after{background-color:#2b5fda}.bsp_org_sel_box /deep/ .ivu-tree .ivu-checkbox-wrapper[data-v-744b9c58]{margin-right:0}.bsp_org_sel_box /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content[data-v-744b9c58]{background-color:#f0f5ff}.bsp-base-form .ivu-radio-inner[data-v-744b9c58],.bsp_org_sel_box /deep/ .ivu-checkbox-inner[data-v-744b9c58]{border-color:#cee0f0}.bsp_org_sel_box .flow-modal-title[data-v-744b9c58]{height:40px;background:#2b5fda;width:100%;text-indent:1em;color:#fff;line-height:40px}/deep/ .bsp_org_sel_box [data-v-744b9c58]{font-size:16px!important}/deep/ .bsp_org_sel_box .ivu-modal-content .ivu-modal-body [data-v-744b9c58],/deep/ .bsp_org_sel_box .ivu-modal-header[data-v-744b9c58]{padding:0}/deep/ .bsp_org_sel_box .ivu-icon-ios-close[data-v-744b9c58]{font-size:32px!important;line-height:40px}/deep/ .bsp-org-input .ivu-input-search[data-v-744b9c58]{font-size:15px;padding:0!important;width:70px;max-width:70px}/deep/ .bsp-org-input .ivu-input-icon[data-v-744b9c58]{right:66px;font-size:20px}/deep/ .bsp-org-input .ivu-input[data-v-744b9c58]{font-size:16px}.bsp-scroll[data-v-744b9c58]::-webkit-scrollbar{width:10px;height:10px}.bsp-scroll[data-v-744b9c58]::-webkit-scrollbar-thumb{border-radius:3px;background:#b7c7dd}.bsp-scroll[data-v-744b9c58]::-webkit-scrollbar-track{border-radius:3px;background:#ededed}", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(6)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context = context || (this.$vnode && this.$vnode.ssrContext)
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    // inject component registration as beforeCreate hook
    var existing = options.beforeCreate
    options.beforeCreate = existing
      ? [].concat(existing, hook)
      : [hook]
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        return: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        button: {
            type: String,
            default: '选择'
        },
        multiple: {
            type: Boolean,
            default: true
        },
        bindEvent: {
            type: Boolean,
            default: true
        },
        rootOrgId: {
            type: String,
            default: ''
        },
        defaultText: {
            type: Boolean,
            default: false
        },
        orgType: {
            type: String,
            default: ''
        },
        // 如果子节点全选则只返回父节点模式
        onlyParent: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            txt: this.text,
            isBuild: false,
            currentNodeId: '',
            searchTxt: '',
            openStatus: false,
            loaded: false,
            clearLoaded: false,
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            selectedOrg: [],
            rootData: [],
            checkedKeys: [],
            expandedKeys: [],
            spinShow: false
        };
    },

    watch: {
        value: {
            handler: function handler(val, oldVal) {
                if (this.defaultText && !this.loaded) {
                    this.getOrgDataByIds();
                }
                if (val === '' && this.clearLoaded) {
                    this.txt = '';
                    this.clearData();
                } else {
                    this.clearLoaded = true;
                }
            },

            immediate: true
        },
        text: {
            handler: function handler(val, oldVal) {
                this.txt = val;
            }
        }
    },
    mounted: function mounted() {
        if (this.bindEvent && this.$slots.func) {
            this.reference = this.$slots.func[0].elm;
            this.reference.addEventListener('click', this.openOrgDialog);
        }
    },

    methods: {
        openOrgDialog: function openOrgDialog() {
            if (this.value) {
                this.checkedKeys = this.value.split(",");
            } else {
                this.checkedKeys = [];
            }
            this.openStatus = true;
            if (this.isBuild) {
                this.$refs.orgTree.setCheckedKeys(this.checkedKeys);
                if (this.onlyParent) {
                    this.selectedOrg = this.getSimpleCheckedNodes(this.$refs.orgTree.store);
                } else {
                    this.selectedOrg = this.$refs.orgTree.getCheckedNodes();
                }
                return;
            }
            this.getOrgData();
        },
        getOrgData: function getOrgData() {
            var _this = this;

            this.spinShow = true;
            var params = { pId: this.rootOrgId, orgType: this.orgType };
            this.$store.dispatch('postRequest', { url: '/bsp-uac/uac/org/getOrgsByPid', params: params }).then(function (resp) {
                // debugger
                _this.spinShow = false;
                if (resp.success) {
                    //let root = this.buildTreeData(resp.data)
                    var roots = _this.transData(resp.data);
                    if (roots && roots.length > 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = roots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var root = _step.value;

                                root.expanded = true;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    var arr = [].concat(_toConsumableArray(roots));

                    _this.rootData = arr;
                    _this.$refs.orgTree.setCheckedKeys(_this.checkedKeys);
                    _this.isBuild = true;
                }
            });
        },
        getOrgDataByIds: function getOrgDataByIds() {
            var _this2 = this;

            if (!this.value) {
                return;
            }
            this.loaded = true;
            var params = { ids: this.value };
            this.$store.dispatch('postRequest', { url: '/bsp-uac/uac/org/findByIds', params: params }).then(function (resp) {
                if (resp.success) {
                    var datas = resp.data;
                    if (datas && datas.length > 0) {
                        var orgNames = [];
                        datas.forEach(function (item) {
                            orgNames.push(item.name);
                        });
                        _this2.txt = orgNames.join(",");
                    }
                }
            });
        },
        buildTreeData: function buildTreeData(datas) {
            var _this3 = this;

            var root = [];
            var mapping = this.treeIdMapping(datas);
            datas.forEach(function (el) {
                if (_this3.checkedKeys.length > 0 && _this3.checkedKeys.includes(el.id)) {
                    _this3.selectedOrg.push(el);
                }
                if (!el.parentId || el.id === _this3.rootOrgId) {
                    root = el;
                    return;
                }
                // 用映射表找到父元素
                var parentEl = datas[mapping[el.parentId]];
                // 把当前元素添加到父元素的`children`数组中
                parentEl.children = [].concat(_toConsumableArray(parentEl.children || []), [el]);
            });
            return root;
        },
        transData: function transData(datas) {
            var r = [],
                hash = {},
                id = 'id',
                pid = 'parentId',
                children = 'children',
                i = 0,
                j = 0,
                len = datas.length;
            for (; i < len; i++) {
                hash[datas[i][id]] = datas[i];
                if (this.checkedKeys.length > 0 && this.checkedKeys.includes(datas[i].id)) {
                    this.selectedOrg.push(datas[i]);
                }
            }
            for (; j < len; j++) {
                var aVal = datas[j],
                    hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            return r;
        },
        treeIdMapping: function treeIdMapping(data) {
            return data.reduce(function (acc, el, i) {
                acc[el.id] = i;
                return acc;
            }, {});
        },
        renderContent: function renderContent(h, _ref) {
            var node = _ref.node,
                data = _ref.data,
                store = _ref.store;

            // debugger
            if (data.expanded) {
                node.expanded = true;
            }
            var type = 'ios-home-outline';
            if (data.children && data.children.length > 0) {
                type = 'ios-folder-outline';
            }
            var hArr = [];
            if (!this.multiple) {
                var checked = false;
                if (data.id === this.currentNodeId) {
                    checked = true;
                }
                hArr.push(h('Radio', {
                    props: {
                        value: checked,
                        size: 'large'
                    }
                }));
            }
            hArr.push(h('Icon', {
                props: {
                    type: type,
                    color: '#6e95f1'
                },
                style: {
                    marginRight: '4px'
                }
            }));
            hArr.push(h('span', {
                style: {
                    fontSize: '16px'
                },
                attrs: {
                    title: data.name
                }
            }, data.name));
            return h('span', hArr);
        },
        filterNode: function filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1 || data.id.indexOf(value) !== -1;
        },
        searchField: function searchField() {
            var searchTxt = this.searchTxt;
            this.$refs.orgTree.filter(searchTxt);
            if (!searchTxt) {
                this.setAllExpand(this.rootData[0].id, false);
            }
        },
        setAllExpand: function setAllExpand(id, state) {
            var nodes = this.$refs.orgTree.store.nodesMap;
            for (var i in nodes) {
                if (id === i) {
                    nodes[i].expanded = true;
                } else {
                    nodes[i].expanded = state;
                }
            }
        },
        treeNodeClick: function treeNodeClick(data, node) {
            this.checkChange(data, node);
            return;
        },
        checkChange: function checkChange(data, node) {
            if (!this.multiple) {
                this.$refs.orgTree.setCheckedNodes([data]);
                this.currentNodeId = data.id;
            }
            if (this.onlyParent) {
                this.selectedOrg = this.getSimpleCheckedNodes(this.$refs.orgTree.store);
            } else {
                this.selectedOrg = this.$refs.orgTree.getCheckedNodes();
            }
        },

        // 返回子节点已经全部被选中的父节点
        getSimpleCheckedNodes: function getSimpleCheckedNodes(store) {
            var checkedNodes = [];
            var traverse = function traverse(node) {
                var childNodes = node.root ? node.root.childNodes : node.childNodes;
                childNodes.forEach(function (child) {
                    if (child.checked) {
                        checkedNodes.push(child.data);
                    }
                    if (child.indeterminate) {
                        traverse(child);
                    }
                });
            };
            traverse(store);
            return checkedNodes;
        },
        deleteSelected: function deleteSelected(data, idx) {
            this.selectedOrg.splice(idx, 1);
            this.currentNodeId = '';
            this.$refs.orgTree.setCheckedNodes(this.selectedOrg);
        },
        deleteAll: function deleteAll() {
            this.selectedOrg = [];
            this.currentNodeId = '';
            this.$refs.orgTree.setCheckedNodes(this.selectedOrg);
        },

        // 弹窗取消事件
        cancel: function cancel() {
            this.openStatus = false;
            this.$emit('on-cancel');
        },
        comfired: function comfired() {
            if (this.selectedOrg.length == 0) {
                this.warnMsg('请选择数据');
                return false;
            }
            var datas = this.buildData(this.selectedOrg);
            this.setData(datas);
            this.openStatus = false;
            this.$emit('on-select', datas);
        },
        buildData: function buildData(datas) {
            var arr = [];
            datas.forEach(function (item) {
                var obj = { orgId: item.id, orgName: item.name, sname: item.sname, fname: item.fname, regId: item.regionId, regName: item.regionName, cityId: item.cityId, cityName: item.cityName };
                arr.push(obj);
            });
            return arr;
        },
        setData: function setData(data) {
            var _this4 = this;

            var ret = {};
            Object.keys(data[0]).forEach(function (key) {
                ret[key.toLowerCase()] = [];
            });
            data.forEach(function (item) {
                for (var key in item) {
                    ret[key.toLowerCase()].push(item[key]);
                }
            });
            this.$emit('input', ret['orgid'].join(','));
            this.txt = ret['orgname'].join(',');
            var fields = this.return.split('|');
            if (fields && fields.length > 0) {
                fields.forEach(function (item) {
                    var field = item.split(':');
                    if (field && field.length >= 2) {
                        var retValArr = ret[field[1].toLowerCase()];
                        var retVal = '';
                        if (retValArr) {
                            retVal = retValArr.join(',');
                        }
                        _this4.$emit('update:' + field[0], retVal);
                    }
                });
            }
        },
        focus: function focus() {
            this.$refs['input'].focus();
        },
        clearData: function clearData() {
            var _this5 = this;

            this.$emit('input', '');
            if (this.return) {
                var fields = this.return.split('|');
                if (fields && fields.length > 0) {
                    fields.forEach(function (item) {
                        var field = item.split(':');
                        if (field && field.length >= 2) {
                            _this5.$emit('update:' + field[0], '');
                        }
                    });
                }
            }
            this.deleteAll();
            this.$emit('on-clear');
        },
        warnMsg: function warnMsg(msg) {
            this.$Modal.warning({
                title: '温馨提示',
                content: msg
            });
        }
    }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.$slots.func) ? _vm._t("func") : _c('Input', {
    ref: "input",
    staticClass: "bsp-org-input",
    attrs: {
      "disabled": _vm.disabled,
      "clearable": "",
      "readonly": _vm.readonly,
      "search": "",
      "enter-button": _vm.button,
      "placeholder": ""
    },
    on: {
      "on-clear": _vm.clearData,
      "on-search": _vm.openOrgDialog
    },
    model: {
      value: (_vm.txt),
      callback: function($$v) {
        _vm.txt = $$v
      },
      expression: "txt"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "closable": false,
      "class-name": "bsp_org_sel_box",
      "width": 900
    },
    model: {
      value: (_vm.openStatus),
      callback: function($$v) {
        _vm.openStatus = $$v
      },
      expression: "openStatus"
    }
  }, [_c('div', {
    staticClass: "flow-modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "17px !important"
    }
  }, [_vm._v("单位选择")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "6px",
      "font-size": "32px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bsp_org_sel_box",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "left-org-tree content-ht",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "org-search-box"
  }, [_c('Input', {
    attrs: {
      "suffix": "ios-search",
      "placeholder": "机构单位查询"
    },
    on: {
      "on-change": _vm.searchField
    },
    model: {
      value: (_vm.searchTxt),
      callback: function($$v) {
        _vm.searchTxt = $$v
      },
      expression: "searchTxt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-box bsp-scroll"
  }, [_c('el-tree', {
    ref: "orgTree",
    attrs: {
      "data": _vm.rootData,
      "node-key": "id",
      "expand-on-click-node": false,
      "show-checkbox": _vm.multiple,
      "check-strictly": !_vm.onlyParent,
      "highlight-current": true,
      "accordion": true,
      "check-on-click-node": true,
      "filter-node-method": _vm.filterNode,
      "indent": 26,
      "render-content": _vm.renderContent,
      "icon-class": "el-icon-arrow-right"
    },
    on: {
      "check": _vm.checkChange
    }
  })], 1), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "right-org-list content-ht"
  }, [_c('div', {
    staticClass: "org-selected-box"
  }, [_c('b', [_vm._v("已选单位")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "2px"
    },
    attrs: {
      "title": "删除全部"
    }
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA10lEQVQ4T2P8//8/MwMVACMugz4aGe1k+P/fGdkORgaGI3znzztgsxfDoI+Ghn+IcSD/+fMsKJbAXESsAeiWwAyEu+ijoeFuBgYGR2Jcg6RmP//5864gPsJrjY3M7w4cECPFICEHh1cM9fV/UQyinteMjSsY/v1rIcVFDExMNfxnz3ageo2BgQHkqv///z9mYGLawPD/fzAjA4PUf0bGyVCFuehyyDGHEv1g7zEy7uU/d879k6Hhgf8MDDYwxfjksLpo1CCU8KNxGJGQkPBHPzUMIsEMDKUAY+HyE69FM1YAAAAASUVORK5CYII="
    },
    on: {
      "click": _vm.deleteAll
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content-box bsp-scroll",
    staticStyle: {
      "background": "#FAFBFF"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "table-layout": "fixed"
    }
  }, _vm._l((_vm.selectedOrg), function(item, i) {
    return _c('tr', {
      key: i,
      attrs: {
        "title": item.name + '(' + item.unitNo + ')'
      }
    }, [_c('td', {
      staticClass: "org-left"
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.unitNo) + ")\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "org-del"
    }, [_c('img', {
      staticClass: "img-box",
      attrs: {
        "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABEUlEQVQ4T2NkwAL6156RZPj1bwMDw38zVGnGUwxsTAGFwSbP0bUxIgs0NPxn4lc/9YWBgYETmwVIYt8/3jTjaWhg/AcTgxvUv/iMJAPL32cEDECV/sMsVRgLcR3YIKhL/pJkCFTxx5tmzCCXgQ3qW3byCyMjAzc5Bv3/z/C1KMqch7Fz+REpNgbWp8iGuJsrMajLCzNMWnUaxey8MFOGGw/fMuw6eQ/Di4z9y0+eYmBgMEWWAWlgYmJk+PfvP9wwbGJIek6DDPqPzUvIGkHy6AZjRD8ug0AKYYaB2Miuw2YxThdRzSByvEadwMYW/W7mSgwapEY/1RIkVbMIyDCqZFpYuqBKMYKcyCARwLaelIINAPXCscs343ggAAAAAElFTkSuQmCC"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSelected(item, i)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticStyle: {
      "margin": "0 15px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取  消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.comfired
    }
  }, [_vm._v("确  认")])], 1)])], 2)
},staticRenderFns: []}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// gs-org-selector.js